var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculadora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;}.cls-2{fill:#556169;}.cls-3{fill:#f97b70;}.cls-4{fill:#8ac3e6;}.cls-5{fill:#53b2d2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calculadora") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.32,
    y: 1.81,
    width: 123.36,
    height: 171.38,
    rx: 3.78,
    ry: 3.78
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.38,
    y: 63.78,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.11,
    y: 63.78,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.83,
    y: 63.78,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.56,
    y: 63.78,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.36,
    y: 89.36,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.09,
    y: 89.36,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.81,
    y: 89.36,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.54,
    y: 89.36,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.36,
    y: 114.94,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.09,
    y: 114.94,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.2,
    y: 140.53,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.93,
    y: 140.53,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.81,
    y: 114.94,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.54,
    y: 114.94,
    width: 16.1,
    height: 16.1,
    rx: 0.5,
    ry: 0.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.81,
    y: 140.53,
    width: 43.83,
    height: 16.1,
    rx: 0.82,
    ry: 0.82
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 13.38,
    y: 13.43,
    width: 99.28,
    height: 40.41,
    rx: 0.71,
    ry: 0.71
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112,13.43H75.52L59.26,53.83H112a.71.71,0,0,0,.71-.71v-39A.71.71,0,0,0,112,13.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculadora);
export default __webpack_public_path__ + "static/media/calculadora.b424e8c2e187f6e9fc091c71246b8944.svg";
export { ForwardRef as ReactComponent };